export const OIL_DISPOSAL_SERVICE_NAME = 'Oil Disposal';
export const HOOD_CLEANING_SERVICE_NAME = 'Hood Cleaning';
export const GREASE_TRAP_SERVICE_NAME = 'Grease Trap Cleaning';
export const FAT_BONES_SERVICE_NAME = 'Meat, Fat & Bone';
export const CONTAINER_DELIVERIES_SERVICE_NAME = 'Container Deliveries';

export const services = [
  OIL_DISPOSAL_SERVICE_NAME,
  HOOD_CLEANING_SERVICE_NAME,
  GREASE_TRAP_SERVICE_NAME,
  FAT_BONES_SERVICE_NAME,
  CONTAINER_DELIVERIES_SERVICE_NAME,
];

export const PAYMENT_TYPES = [
  'Cash',
  'Contract',
  'C.O.D.',
  'Warranty',
  'Estimate',
  'Charge',
];

export const HOOD_CLEANING_SERVICES = [
  'Hood Cleaning',
  'Filters Cleaning Exchange',
  'Equipament Cleaning & Maintenance',
  'Floors & Walls Cleaning',
  'Hood Blower Motor & Bearing Repair',
  'V-belts',
  'Exhaust Cleaning',
  'Other',
];

export const CONTAINER_DELIVERIES_DROP_OFF_SIZE = [
  '45 Gal',
  '55 Gal',
  '80 Gal',
  '120 Gal',
  'Special Requirements',
];
